import { Injectable, inject } from '@angular/core';
import { from, Observable } from 'rxjs';
import { filter, map, mergeMap, shareReplay, toArray } from 'rxjs/operators';
import { BildungsangebotDetail } from '../../model/bildungsangebot-detail';
import { EntgeltatlasClient } from '../integration/entgeltatlas-client.service';

@Injectable({
  providedIn: 'root'
})
export class EntgeltatlasService {
  private readonly entgeltatlasClient = inject(EntgeltatlasClient);

  private static getAktuelleDSystematiken(angebot: BildungsangebotDetail): number[] {
    return angebot.systematiken
      .filter(({ codeNr }) => codeNr.startsWith('D'))
      .map(({ dkzid }) => dkzid);
  }

  public getMedianBausteine$: (angebot: BildungsangebotDetail) => Observable<string[]> = (
    angebot
  ) =>
    from(EntgeltatlasService.getAktuelleDSystematiken(angebot)).pipe(
      mergeMap((dkzId) =>
        this.entgeltatlasClient
          .getPrimaererMedian(dkzId)
          .pipe(map((baustein) => ({ dkzId, baustein })))
      ),
      filter(({ baustein }) => baustein !== null),
      toArray(),
      map((bausteine) => {
        bausteine.sort((a, b) => a.dkzId - b.dkzId);
        return bausteine.map(({ baustein }) => baustein);
      }),
      shareReplay(1)
    );
}
